/* eslint-disable no-param-reassign */
import axios from 'axios';
import urlData from '../config';

/**
 * GETs use the WebView fetch when CapacitorHttp has replaced window.fetch.
 * The native HTTP patch fixes login POSTs, but a later native GET can hang,
 * which leaves Step 1 on the empty "FITNESS Complete!" slide.
 */
async function requestGet(fullUrl, headers) {
    const doFetch = window.CapacitorWebFetch || window.fetch;
    const res = await doFetch(fullUrl, {
        method: 'GET',
        headers,
        signal:
            typeof AbortSignal !== 'undefined' && AbortSignal.timeout
                ? AbortSignal.timeout(20000)
                : undefined,
    });
    const text = await res.text();
    let body = text;
    if (text) {
        try {
            body = JSON.parse(text);
        } catch (error) {
            body = text;
        }
    }
    if (!res.ok) {
        const err = new Error('request failed');
        err.response = { status: res.status, data: body };
        throw err;
    }
    return body;
}

const request = async (params) => {
    const { url, method = 'get', data = {}, headers = {}, token = '' } = params;

    try {
        // Resolve each call so LAN/phone rewrite in config.js always applies.
        const base = String(urlData.SERVER_URL || '').replace(/\/?$/, '/');
        const fullUrl = `${base}${url}`;

        if (token) headers.Authorization = `Bearer ${token}`;

        const verb = String(method || 'get').toLowerCase();
        if (verb === 'get') {
            const body = await requestGet(fullUrl, headers);
            return { error: '', data: body, status: 200 };
        }

        const response = await axios({
            method,
            headers,
            url: fullUrl,
            data,
        });

        return { error: '', data: response.data, status: '' };
    } catch (err) {
        return { error: err, data: '', status: err.response?.status };
    }
};

export default request;
